const BUKAREKSA_TAG_ID = 1465456;
const BUKAREVIEW_WEBSITE_ID = 1;

module.exports = {
  BUKAREKSA_TAG_ID,
  BUKAREVIEW_WEBSITE_ID,
};
